import { apiCall } from '../../utils/saga';

export const sendContactMessage = payload =>
  apiCall({
    url: '/email/contact-us/',
    method: 'post',
    data: payload,
  });